import moment from "moment";
import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { IoPagination } from "../../../../helper/pagination";
import {
  Promotion, PromotionInquiry,
  PromotionUI
} from "../entity/promotion.model";

async function getPromotions(
  inquiry: PromotionInquiry
): Promise<IoPagination<PromotionUI>> {
  if (inquiry.name === undefined) {
    delete inquiry.name;
  }

  let pagePromotion: IoPagination<PromotionUI> = await api.get(
    `${mConstants.PROMOTION_URL}/promotions`,
    {
      params: inquiry,
    }
  );

  pagePromotion.content = pagePromotion.content.map((x) => {
    return { ...x, value: x.uuid, label: x.name };
  });

  return pagePromotion;
}

async function getPromotion(uuid: string): Promise<PromotionUI> {
  let promotion: Promotion = await api.get(
    `${mConstants.PROMOTION_URL}/promotions/${uuid}`
  );
  
  return {
    ...promotion,
    startDate: moment(promotion.startDate),
    endDate: moment(promotion.endDate),
    label: promotion.name,
    value: promotion.uuid,
  };
}

function editPromotion(promotion: PromotionUI): Promise<void> {
  let _promotion: Promotion = convertPromotionUI(promotion);
  return api.put(`${mConstants.PROMOTION_URL}/promotions`, _promotion);
}

function addPromotion(promotion: PromotionUI): Promise<PromotionUI> {
  let _promotion: Promotion = convertPromotionUI(promotion);
  return api.post(`${mConstants.PROMOTION_URL}/promotions`, _promotion);
}

function deletePromotion(uuid: string) {
  return api.delete(`${mConstants.PROMOTION_URL}/promotions/${uuid}`);
}

function convertPromotionUI(promotion: PromotionUI): Promotion {
  return {
    ...promotion,
    startDate: promotion.startDate?.format(mConstants.DATE_FORMAT)!,
    endDate: promotion.endDate?.format(mConstants.DATE_FORMAT)!,
  };
}

export const promotionService = {
  getPromotions,
  getPromotion,
  deletePromotion,
  editPromotion,
  addPromotion,
};
